// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** Get all partner information GET /api/v1/partner/all */
export async function partnerControllerGetAllPartner(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.PartnerControllerGetAllPartnerParams,
  options?: { [key: string]: any },
) {
  return request<API.PartnerListPayloadDto>('/api/v1/partner/all', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** Search route that partner can see GET /api/v1/partner/search/route */
export async function partnerControllerSearchRoute(options?: {
  [key: string]: any;
}) {
  return request<API.PartnerRoutePayloadDto[]>('/api/v1/partner/search/route', {
    method: 'GET',
    ...(options || {}),
  });
}
